export default "__VITE_ASSET__EGsYMjg5__"